import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const Spinner: React.FC<{ size: number | string; }> = ({ size }) => (
    <Box width="100%" height="100%" display="flex" alignItems="center" justifyContent="center">
        <CircularProgress size={size} />
    </Box>
);

export default Spinner;